/* eslint-disable prettier/prettier */
import { clsx } from 'clsx'
import { PropertyValueMap,unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '../../../../internal/dds-hu-element'
import styles from '../../../icon/_styles/icon.scss?inline'

/**
 * `dap-ds-icon-cookie-line`
 * @summary An icon
 * @element dap-ds-icon-cookie-line
 * @title - OthersCookieLine
 * @group icon
 * @icontype others
 * 
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
@customElement('dap-ds-icon-cookie-line')
export default class OthersCookieLine extends DdsElement {
  /** (optional) The width and height in pixels */
  @property({ type: Number, reflect: true }) size? = 24
  /** (optional) Sets the icon color via the `fill` attribute */
  @property({ type: Boolean, reflect: true }) selected?: boolean = false
  /** (optional) When using the icon standalone, make it meaningful for accessibility */
  @property() accessibilityTitle?: string
  /** (optional) If `true` the icon can receive focus */
  @property({ type: Boolean }) focusable?: boolean = false

  static readonly styles = unsafeCSS(styles)

  protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties)

    this.classList.add('dap-ds-icon')
  }

  render() {
    return html`
      <svg
        part="base"
        class=${clsx('icon', 'dap-ds-icon-cookie-line')}
        xmlns="http://www.w3.org/2000/svg"
        width=${this.size}
        height=${this.size}
        viewBox="0 0 24 24"
        tabindex=${this.focusable ? 0 : -1}
        aria-hidden=${this.ariaHidden}>
        ${this.accessibilityTitle
          ? html`<title>${this.accessibilityTitle}</title>`
          : null}
        <g part="container">
          <g>
            <path fill-rule="evenodd" d="M19.999 11.893v.007zm-.062 1.116C19.439 16.945 16.067 20 12 20c-4.41 0-8-3.59-8-8 0-4.068 3.056-7.439 6.991-7.937.172.356.396.683.666.972-.22.95-.082 1.968.423 2.843a3.92 3.92 0 0 0 2.253 1.789 3.92 3.92 0 0 0 3.744 2.778q.451 0 .887-.103c.289.27.617.495.973.667M16.17 8.35a1.93 1.93 0 0 0 .951 1.837 1.92 1.92 0 0 0 2.067-.094.48.48 0 0 1 .711.19c.3.65.93 1.077 1.644 1.113a.48.48 0 0 1 .455.473l.001.04L22 12c0 5.514-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2l.092.001h.04a.48.48 0 0 1 .472.456A1.91 1.91 0 0 0 13.716 4.1a.48.48 0 0 1 .19.712c-.43.61-.466 1.42-.094 2.066a1.93 1.93 0 0 0 1.837.951.48.48 0 0 1 .521.521m-3.293-2.435h-.002z" clip-rule="evenodd"></path><path d="M10 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M8 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2"></path>
          </g>
        </g>
      </svg>
    `
  }
}
